/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HygieneMonitoringInformation } from './HygieneMonitoringInformation';
import {
    HygieneMonitoringInformationFromJSON,
    HygieneMonitoringInformationFromJSONTyped,
    HygieneMonitoringInformationToJSON,
} from './HygieneMonitoringInformation';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableHygieneMonitoringInformation
 */
export interface PageableHygieneMonitoringInformation {
    /**
     * 
     * @type {Array<HygieneMonitoringInformation>}
     * @memberof PageableHygieneMonitoringInformation
     */
    result: Array<HygieneMonitoringInformation>;
    /**
     * 
     * @type {Page}
     * @memberof PageableHygieneMonitoringInformation
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableHygieneMonitoringInformation interface.
 */
export function instanceOfPageableHygieneMonitoringInformation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableHygieneMonitoringInformationFromJSON(json: any): PageableHygieneMonitoringInformation {
    return PageableHygieneMonitoringInformationFromJSONTyped(json, false);
}

export function PageableHygieneMonitoringInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableHygieneMonitoringInformation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(HygieneMonitoringInformationFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableHygieneMonitoringInformationToJSON(value?: PageableHygieneMonitoringInformation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(HygieneMonitoringInformationToJSON)),
        'page': PageToJSON(value.page),
    };
}

